import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { bubEvents } from 'javascripts/shared/events/bub_events';
import { graphQL } from 'javascripts/shared/graphql';
import { graphQLMutations } from 'javascripts/shared/graphql/mutations';
import { graphQLUtils } from 'javascripts/shared/utils/graphql_utils';

import { FollowButton } from 'javascripts/components/follow_button';

const FOLLOWING_ERROR_ACTION = 'following';
const UNFOLLOWING_ERROR_ACTION = 'unfollowing';
const FOLLOW_SOURCE = 'FOLLOW_BUTTON';

export function PersonFollowButton({
  displayStyle,
  followingText,
  followText,
  onError,
  onFollowChange,
  person: { id: personId, slug, followedByCurrentUser },
  trackingCategory,
}) {
  const [isFollowing, setIsFollowing] = useState(followedByCurrentUser);

  useEffect(() => {
    setIsFollowing(followedByCurrentUser);
  }, [followedByCurrentUser]);

  function trackClick() {
    if (!_.isNil(trackingCategory)) {
      bubEvents.track(trackingCategory, 'Clicked button', {
        label: 'Author follow status',
        value: isFollowing ? 'Unfollow' : 'Follow',
        person_id: personId,
      });
    }
  }

  function onClick(event) {
    trackClick();

    if (isFollowing) {
      graphQL
        .get(graphQLMutations.unfollowPerson, { slug, source: FOLLOW_SOURCE })
        .then(() => {
          setIsFollowing(false);
          onFollowChange({ following: false });
        })
        .catch(error => {
          const msg = graphQLUtils.friendlyGraphQLErrorMessage(error);
          onError(UNFOLLOWING_ERROR_ACTION, msg);
        });
    } else {
      graphQL
        .get(graphQLMutations.followPerson, { slug, source: FOLLOW_SOURCE })
        .then(() => {
          setIsFollowing(true);
          onFollowChange({ following: true });
        })
        .catch(error => {
          const msg = graphQLUtils.friendlyGraphQLErrorMessage(error);
          onError(FOLLOWING_ERROR_ACTION, msg);
        });
    }
    event.preventDefault();
  }

  return (
    <FollowButton
      displayStyle={displayStyle}
      followingText={followingText}
      followText={followText}
      isFollowing={isFollowing}
      onClick={onClick}
    />
  );
}

PersonFollowButton.propTypes = {
  displayStyle: PropTypes.string,
  followingText: PropTypes.string,
  followText: PropTypes.string,
  onError: PropTypes.func,
  onFollowChange: PropTypes.func,
  person: PropTypes.shape({
    id: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    followedByCurrentUser: PropTypes.bool,
  }).isRequired,
  trackingCategory: PropTypes.string,
};

PersonFollowButton.defaultProps = {
  onError: _.noop,
  onFollowChange: _.noop,
};
